<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Incluir Tag
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-select
            v-model="tagType"
            :items="tagTypes ? tagTypes : []"
            item-text="name"
            item-value="id"
            label="Tipo da Tag"
            @change="getTags"
          />
          <v-select
            v-model="tag"
            :items="tags ? tags : []"
            item-text="name"
            item-value="id"
            label="Tag"
            :disabled="tagType ? false : true"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    tagTypes: [],
    tags: [],
    tagType: null,
    tag: null
  }),
  async mounted () {
    await this.getTagTypes()
  },
  methods: {

    async getTagTypes () {
      try {
        const responseTagTypes = await this.$api.getTagTypes()
        this.tagTypes = responseTagTypes
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter tipos de tag, tente novamente mais tarde.', color: 'red' })
      }
    },

    async getTags () {
      try {
        const responseTags = await this.$api.getTagType(this.tagType)
        this.tags = responseTags.tags
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter tags, tente novamente mais tarde.', color: 'red' })
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit () {
      const save = {
        tag_id: this.tag
      }
      this.$emit('resolve', save)
    }
  }
}
</script>
